export default "__VITE_ASSET__C$BIr9Fc__"